import OrgDataTempl from "./modules/OrgDataTemplStore.js";
import DocIdTempl from "./modules/DocIdTemplStore";
import Files from "./modules/FileStore";
import Classification from "./modules/ClassificationStore";
import RefObj from "./modules/RefObjStore";
import DocVer from "./modules/DocVersionStore";
import ActivationSteps from "./modules/ActivationStepsStore";
import ViewerStore from "./modules/ViewerStore.js";

import Vuex from "vuex";
import { createStore } from "vuex-extensions";

export default createStore(Vuex.Store, {
  modules: {
    OrgData: OrgDataTempl,
    DocId: DocIdTempl,
    Files: Files,
    Classification: Classification,
    RefObj: RefObj,
    DocVer: DocVer,
    ActSteps: ActivationSteps,
    ViewerStore: ViewerStore,
    
  },
  state() {
    return {
      isContainer: false,
      fileSelected: false,
      nextRound: false,
      filesConfirmed: false,
      documentationName: '',
      MainXmlDocIdArray: [],
      MainPdfDataArray: [],
      isInstance: undefined,
      editingFinished: false,
      objIdLengthOptData: 9,
      isPackageUnit: false,
      cookieStatus: null,
      acceptToS: false,
    };
  },
  getters: {
    getAcceptToS(state){
      return state.acceptToS
    },
    getCookieStatus(state){
      return state.cookieStatus
    },
    getObjIdLengthOptData(state){
      return state.objIdLengthOptData
    },
    getIsPackageUnit(state){
      return state.isPackageUnit
    },
    getEditing(state){
      return state.editingFinished
    },

    getMainXmlDocIdArray(state) {
      return state.MainXmlDocIdArray;
    },
    getMainDocumentId: (state) => (index) => {
      return state.MainXmlDocIdArray[index].DocumentId;
    },
    getMainDomainId: (state) => (index) => {
      return state.MainXmlDocIdArray[index].DomainId;
    },
    getMainIsPrimary: (state) => (index) => {
      return state.MainXmlDocIdArray[index].IsPrimary;
    },
    getMainDocumentDomainId: (state) => (index) => {
      return state.MainXmlDocIdArray[index].DocumentDomainId;
    },

    getMainPdfDataArray(state) {
      return state.MainPdfDataArray;
    },
    getIsContainer(state) {
      return state.isContainer;
    },
    getFileSelected(state) {
      return state.fileSelected;
    },
    getNextRound(state) {
      return state.nextRound;
    },
    getFilesConfirmed(state) {
      return state.filesConfirmed;
    },
    getDocumentIdTemplate(state) {
      return state.documentIdTemplate;
    },
    getDocumentationName(state) {
      return state.documentationName;
    },
    getIsInstance(state) {
      return state.isInstance;
    },
  },
  mutations: {
    setAcceptToS(state, payload){
      state.acceptToS = payload
    },
    setCookieStatus(state, payload){
      state.cookieStatus = payload
    },
    setIsPackageUnit(state, payload){
      state.isPackageUnit = payload
    },
    setObjIdLengthOptData(state, payload){
      state.objIdLengthOptData = payload
    },
    setEditing(state, payload) {
      state.editingFinished = payload;
    },
 
    setContainerState(state, is_container) {
      state.isContainer = is_container;
    },
    setFileSelectionState(state, selected) {
      state.fileSelected = selected;
    },
    setNextRound(state, value) {
      state.nextRound = value;
    },
    setFilesConfirmed(state, value) {
      state.filesConfirmed = value;
    },
    setDocumentationName(state, docName) {
      state.documentationName = docName;
    },
    addMainXmlDocIdItem(state, payload) {
      state.MainXmlDocIdArray.push(payload);
    },
    addMainPdfDataArray(state, payload) {
      state.MainPdfDataArray.push(payload);
    },
    setIsInstance(state, payload) {
      state.isInstance = payload;
    },

  },

  actions: {
    setAcceptToS(context, payload){
      context.commit("setAcceptToS", payload)
    },
    setCookieStatus(context, payload){
      context.commit("setCookieStatus", payload)
    },
    setEditing(context, payload){
      context.commit("setEditing", payload)
    },
    setIsPackageUnit(context, payload){
      context.commit("setIsPackageUnit", payload)
    },
    setObjIdLengthOptData(context, payload){
      context.commit("setObjIdLengthOptData", payload)
    },
    setFileSelectionState(context, payload) {
      context.commit("setFileSelectionState", payload);
    },
    setNextRound(context, payload) {
      context.commit("setNextRound", payload);
    },
    setFilesConfirmationState(context, payload) {
      context.commit("setFilesConfirmed", payload);
    },
    setDocumentationName(context, payload) {
      context.commit("setDocumentationName", payload);
    },
    addMainXmlDocIdItem(context, payload) {
      context.commit("addMainXmlDocIdItem", payload);
    },
    addMainPdfDataArray(context, payload) {
      context.commit("addMainPdfDataArray", payload);
    },
    setIsInstance(context, payload) {
      context.commit("setIsInstance", payload);
    },
 
  },
});
